var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "has-margin-top" }, [
    _c(
      "div",
      {
        staticClass: "bp-panel has-no-title",
        staticStyle: { "min-height": "auto" },
      },
      [
        _c("div", { staticClass: "panel-content" }, [
          _c("div", { staticClass: "columns has-seperating-borders" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", [
                _c("h4", [_vm._v(_vm._s(_vm.publication.website.name))]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "is-small-text",
                    class: {
                      "is-text-red": _vm.publication.status === "notPublished",
                      "is-text-yellow": _vm.publication.status === "staged",
                      "is-text-blue": _vm.publication.status === "published",
                    },
                  },
                  [_vm._v(_vm._s(_vm.getStatusText(_vm.publication)))]
                ),
                _vm._v(" "),
                _vm.publication.lastError
                  ? _c(
                      "p",
                      {
                        staticClass: "is-small-text",
                        staticStyle: { color: "#e3342f" },
                      },
                      [_vm._v(_vm._s(_vm.publication.lastError))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "is-small-text mt-1" },
                _vm._l(_vm.publication.website.locales, function (locale) {
                  return _c(
                    "span",
                    {
                      key: locale,
                      staticClass: "tag is-rounded",
                      class: _vm.publication.publishedLocales.includes(locale)
                        ? "is-primary"
                        : "is-light",
                      staticStyle: { "margin-right": "4px" },
                    },
                    [_vm._v(_vm._s(locale))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "is-small-text" }, [
                _c(
                  "a",
                  {
                    staticClass: "is-text-link-color",
                    attrs: {
                      target: "_blank",
                      href: _vm.getUrl(_vm.publication),
                    },
                  },
                  [_vm._v("Ansehen")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "level level-left mt-4" }, [
                _c("div", { staticClass: "control level-item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-full-width",
                      class: {
                        "is-loading": _vm.loadingId === _vm.publication.id,
                      },
                      attrs: { disabled: _vm.loadingId !== null },
                      on: {
                        click: function ($event) {
                          return _vm.publish(_vm.publication, "stage")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("sync"),
                      ]),
                      _vm._v(" Auf Testseite\n                            "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control level-item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-full-width is-primary",
                      class: {
                        "is-loading": _vm.loadingId === _vm.publication.id,
                      },
                      attrs: { disabled: _vm.loadingId !== null },
                      on: {
                        click: function ($event) {
                          return _vm.publish(_vm.publication, "publish")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("public"),
                      ]),
                      _vm._v(" Veröffentlichen\n                            "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.publication.status === "published" ||
                _vm.publication.status === "staged"
                  ? _c("div", { staticClass: "control level-item" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-full-width is-danger",
                          class: {
                            "is-loading": _vm.loadingId === _vm.publication.id,
                          },
                          attrs: { disabled: _vm.loadingId !== null },
                          on: {
                            click: function ($event) {
                              return _vm.unpublish(_vm.publication)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                          _vm._v(" Entfernen\n                            "),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }